import React, { useEffect, useState } from "react";
import HubspotForm from "react-hubspot-form";
import { Circles } from "react-loader-spinner";
import { preventFormSubmissionForInternalUsers } from "../Helpers/helpers";

const Loader = () => {
  return (
    <div
      style={{
        width: "100%",
        height: "100%",
        display: "flex",
        alignItems: "center",
        justifyContent: "center",
      }}
    >
      <Circles
        height="50"
        width="50"
        color="#ee6635"
        ariaLabel="circles-loading"
        wrapperStyle={{}}
        wrapperClass=""
        visible={true}
      />
    </div>
  );
};

function FeedBackForm() {
  const [loading, setLoading] = useState(true);

  useEffect(() => {
    if (loading) return;
    // const timerId = setTimeout(preventFormSubmissionForInternalUsers, 1000);
    // return () => {
    //   if (timerId) clearTimeout(timerId);
    // };
  }, [loading]);

  return (
    <HubspotForm
      region="na1"
      version="V2_PRERELEASE"
      portalId="6917454"
      formId="a30cb5fe-15ab-477b-86c7-e08f359527d5"
      loading={<Loader />}
      onReady={() => setLoading(false)}
    />
  );
}

export default FeedBackForm;
